import Icon from '@mui/material/Icon'
import Menu from '@mui/material/Menu'
import React from 'react'

import Button from '@/app/component/atom/button'
import DateTimeRange from '@/app/component/atom/form/date-time-range'
import type { RecordingsDateRange } from '@/app/module/reports/call-recordings-query'
import { formatDateTime } from '@/app/service/util/format'

type Props = {
  disabled?: boolean
  value?: RecordingsDateRange
  onChange: (value?: RecordingsDateRange) => void
}

const CallRecordingsDateFilter: React.FC<Props> = ({ disabled, value, onChange }) => {
  const [anchor, setAnchor] = React.useState<HTMLElement | null>(null)
  const fromLabel = value?.from ? formatDateTime(value.from) : 'Any date'
  const toLabel = value?.to ? formatDateTime(value.to) : 'Any date'
  const label = value?.from || value?.to ? `${fromLabel} – ${toLabel}` : 'All dates'

  return (
    <>
      <Button
        disabled={disabled}
        endIcon={<Icon>arrow_drop_down</Icon>}
        startIcon={<Icon>filter_list</Icon>}
        tooltip={label}
        variant="outlined"
        onClick={(event) => setAnchor(event.currentTarget)}
      >
        Date
      </Button>
      <Menu anchorEl={anchor} open={!!anchor && !disabled} onClose={() => setAnchor(null)}>
        {anchor && !disabled && (
          <div>
            <DateTimeRange
              disableFuture
              name="recording-dates"
              value={value}
              onChange={({ value: dates }) => {
                onChange(dates.from || dates.to ? dates : undefined)
                setAnchor(null)
              }}
              onClear={() => {
                onChange(undefined)
                setAnchor(null)
              }}
            />
          </div>
        )}
      </Menu>
    </>
  )
}

export default CallRecordingsDateFilter
